import { render, staticRenderFns } from "./aquacultureProduct.vue?vue&type=template&id=560f8339&scoped=true"
import script from "./aquacultureProduct.vue?vue&type=script&lang=js"
export * from "./aquacultureProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f8339",
  null
  
)

export default component.exports